// extracted by mini-css-extract-plugin
export default {"indicator":"CircularProgress_indicator__tzV0l"};